import { render, staticRenderFns } from "./AuthDash.vue?vue&type=template&id=7932a5e4&scoped=true"
import script from "./AuthDash.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthDash.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AuthDash.vue?vue&type=style&index=0&id=7932a5e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7932a5e4",
  null
  
)

export default component.exports